import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceFunction',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      
      // テーブルオプション
      tableColumns: [
        'serviceFunctionId',
        'functionName',
        'deliveryType',
        'detailButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          serviceFunctionId: '機能ID',
          functionName: '機能名',
          deliveryType: '配信タイプ',
          detailButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          serviceFunctionId: 'wp-5',
          functionName: '',
          deliveryType: '',
          detailButton: 'wp-5',
          deleteButton: 'wp-5'
        },
        sortable: [
          'serviceFunctionId',
          'functionName',
          'deliveryType'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('適用機能'),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      deleteTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceFunction.categoryName,
      serviceName: state => state.serviceFunction.serviceName,

      // model
      functionModel: state => state.serviceFunction.functionModel,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,
      
      // modal
      updatedList: state => state.serviceSelectFunctionModal.updated
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
  },
  watch: {
    updatedList: function (to) {
      // モーダルで対象機能の変更がされたら一覧を更新
      this.init()
    },
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceFunction/loadModel',
      showServiceSelectFunctionModal: 'serviceSelectFunctionModal/show'
    }),

    init () {
      this.loading = true

      //
      let functionParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        functionParams: functionParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.functionModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 削除
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceFunctionUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      // switch (key) {
      //   case 'Status':
      //     return Utility.getConstantsLabel([key], value)
      // }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },
    
    showFunctionSelector () {
      this.showServiceSelectFunctionModal(this.serviceId)
    },

    detailItem (props) {
      this.$router.push({
        name: 'ServiceFunctionDetail',
        params: {
          serviceId: this.serviceId,
          functionId: String(props.row.serviceFunctionUuid)
        }
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.serviceFunctionUuid
      // confirm
      const id = Utility.getObjectArrayValue(this.functionModel, 'serviceFunctionUuid', this.deleteTargetId, 'serviceFunctionId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    }
  }
}